import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

export default styled(Spacer)`
  height: 100%;
  display: flex;
  align-items: center;
  border-right: 1px solid var(--grey200);
`;
